const diffInDays = (startDate, endDate) => {
  let difference = endDate.getTime() - startDate.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
};

export default diffInDays;
